import React, {useContext, useLayoutEffect, useState} from "react";
import {IStepQuiz} from "../../../interfaces/IStepQuiz";
import {CardActionArea, Checkbox, FormControlLabel, IconButton, Snackbar} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Colors from "../../../styles/colors";
import {AppContext} from "../../../App";
import {AppService} from "../../../services/app.service";
import CloseIcon from "@material-ui/icons/Close";
import QuizHeader from "./QuizHeader";


const useStyles = makeStyles((theme) => ({
    questionItem:  {
        marginRight: 20,
        marginLeft: 20,
        borderRadius: 2,
        height: 56,
        width: 'calc(100% - 40px)',
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: '#e5e8eb',
        marginBottom: 16,
        color: Colors.lessDark,
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "normal",
        fontSize: 16,
    },
    radio: {
        '&$checked': {
            color: Colors.primary,
        },
    },
    checked: {
        '&$checked': {
            color: Colors.white,
        },
    },
    actionArea: {
        paddingLeft: 24,
        paddingRight: 24,
    },
    filler: {
        paddingBottom: 200,
    },
    buttonStep: {
        width: '100%',
        borderRadius: 5,
        backgroundColor: Colors.primary,
        opacity: 5,
        height: 56,
        color: "white",
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "bold",
        textTransform: "none",
        letterSpacing: 0.25,
        fontSize: 18,
        fontStretch: "normal",
        textAlign: "center",
    },
    mainContainer: {
        width: '100%',
        overflowY: "scroll",
        height: window.innerHeight,
    },
    checkSelected: {
        height: 56,
        borderRadius: 2,
        boxShadow: '0 3px 3px 0 rgba(71, 138, 202, 0.2)',
        backgroundColor: Colors.primary,
        marginBottom: 16,
        color: Colors.white,
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "normal",
        fontSize: 16,

        marginRight: 20,
        marginLeft: 20,
        width: 'calc(100% - 40px)',
    },

}));

interface ICheckValues {
    [key: string]: boolean
}

function MultipleCheck(props: IStepQuiz){
    const [open, setOpen] = useState<boolean>(false)
    const [alertMsg, setAlertMsg] = useState<string>("")
    const classes = useStyles();
    const context = useContext(AppContext);

    const [checkValues, setCheckValues] = React.useState<ICheckValues>({});
    let checkedItems: ICheckValues = {}
    const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        checkedItems = checkValues;
        checkedItems[`${event.target.name}`] = event.target.checked
        setCheckValues( {...checkedItems});
        console.log('checked',checkValues)
    };

    // let screen: any = context.quizResponse;
    // screen[`${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}`] = checkedItems;
    // context.setQuizResponse(screen)

    let questionConfig: any = props.questionConfig;
    let choices = []
    let questionItems: any = Object.values(questionConfig)[0]
    // console.log(questionItems);


    for(let i = 0; i < questionItems.length; i++){
        let checkItem: string = `check${i}`;
        choices.push(
            <FormControlLabel
                key={checkItem}
                className={checkValues[`${checkItem}`] ? classes.checkSelected : classes.questionItem}
                control={<Checkbox classes={{ root: classes.radio, checked: classes.checked }}
                                   checked={checkValues[`${checkItem}`] ?? false}
                                   onChange={handleCheckChange}
                                   name={checkItem} />}
                label={questionItems[i]}/>
        );
    }

    function saveResponse(weekNo: number, taskNo: number, stepNo: number, response: any) {
        let appService = new AppService();
        let _ = appService.saveQuizResponse(response, props.id, `${weekNo}${taskNo}${stepNo}`);
        console.log(_);

    }

    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function handleAction() {
        if(isResponseValid()){
            saveResponse(Number(context.currentWeekNo),
                Number(context.currentTaskNo),
                Number(context.currentStepNo),
                JSON.stringify(checkValues));
            props.moveNext()
        }
    }

    //validate values according to screen rules
    function isResponseValid(): boolean{

        // week 2 final step needs to check all
        if(Number(context.currentWeekNo) === 2 &&
            Number(context.currentTaskNo) === 16 &&
            Number(context.currentStepNo) === 0) {

            console.log('checked', checkValues);
            let checkedItems: number = 0;
            Object.entries(checkValues).forEach(
                ([key, value]) => {
                    if(value === true){
                        checkedItems++;
                    }

                }
            );

            if(checkedItems === questionItems.length){
               return true
            } else {
                setAlertMsg('Please check all to proceed');
                setOpen(true);
                return false
            }

        } else {
            // week 2 final step needs to check all
            let checkedItems: number = 0;
            Object.entries(checkValues).forEach(
                ([key, value]) => {
                    if(value === true){
                        checkedItems++;
                    }
                }
            );

            if(checkedItems > 0){
                return true
            } else {
                setAlertMsg('Please respond by checking to proceed.');
                setOpen(true);
                return false
            }
        }
    }

    useLayoutEffect(()=> {
        async function getResponse(){
            let appService = new AppService();
            const existing_response = await appService.getQuizResponse(props.id);
            console.log(existing_response.data.payload.saved_response)

            if(Object.keys(existing_response.data.payload.saved_response).length > 0){
                let savedResponse = JSON.parse(existing_response.data.payload.saved_response);
                setCheckValues(savedResponse);
            } else {
                setCheckValues({});
            }

        }
        getResponse();
    }, [context.currentTaskNo, props.id]);


    return(
        <div>
            <div className={'multi-check'}>
                <QuizHeader question={props.prompt} customLabel={'QUIZ'}/>
                <div className={'multi-check-container'}>
                    {choices}
                </div>

                <div className={'filler'}/>
                <div className={'mc-quiz-action-area'}>
                    <CardActionArea className={'transcript-previous-button'} onClick={props.moveBack}>
                        Previous
                    </CardActionArea>
                    <CardActionArea className={'transcript-button'} onClick={handleAction}>
                        {(props.buttonLabel) ? props.buttonLabel : "Next"}
                    </CardActionArea>
                </div>
            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={alertMsg}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </div>
    )
}

export default MultipleCheck;